module.exports = __webpack_public_path__ + "static/media/A18040103_10002_6.95299c7a.jpg";